PopOver = require 'app/scripts/views/lib/pop-over'
View = require 'app/scripts/views/internal/view'
SetTagView = require './set-tag-view'

module.exports = class EditTagView extends SetTagView
  getName: ->
    @model.get('name')

  onSubmit: (name) ->
    if name
      @model.update({ name })
      PopOver.popView()
    return

  onDelete: ->
    @model.destroy()
    PopOver.popView()

  viewTitleKey: 'edit tag'
